export default {
  methods: {

    draw_Table() {
      
      let tbl = this.table
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${tbl.y})`)

      let y_ = 0, mY = 0

      this.rawData.forEach((d,i)=> {

        mY  = y_ - tbl.lineHeight/2
        this.columns.forEach(col=> {

          if(col.code == 'ACTIVE') {

            table
            .append('rect')
            .attr('x', col.sx).attr('y', mY - tbl.tSize/2)
            .attr('width', col.width).attr('height', tbl.tSize).attr('fill', '#bcbcbc').attr('opacity', .15)

            table
            .append('rect')
            .attr('transform', `translate(${col.sx}, ${mY - tbl.tSize/2})`)
            .attr('width',  this.axis(d[col.code])).attr('height', tbl.tSize)
            .attr('stroke-width', 0.3)
            .attr('stroke', tbl.bStroke).attr('stroke-opacity', .5)
            .attr('fill', tbl.bColor)
            .attr('fill-opacity', tbl.opacity)

            let tX = 0, tAlign = ''
            if(d[col.code] < (this.table.maxValue * .7)) {
              tX = col.sx + this.axis(d[col.code]) + 2
              tAlign = 'start'
            } else {
              tX = col.sx + this.axis(d[col.code]) - 2
              tAlign = 'end'
            }

            table
            .append('text')
            .attr('id', `${col.code}_${i}_${this.localId}`)
            .attr('transform', `translate(${tX}, ${mY + tbl.tSize*0.36})`)
            .attr('text-anchor', tAlign)
            .attr('font-size', tbl.tSize).attr('fill', col.tColor)
            .attr('cursor', col.filter !== '' ? 'pointer' : 'default')
            .text(d[col.code])
            .call(this.call_LINK, i, tX, mY + tbl.tSize*0.36, tAlign, col)

          } else {

            table
            .append('text')
            .attr('id', `${col.code}_${i}_${this.localId}`)
            .attr('transform', `translate(${col.x}, ${mY + tbl.tSize*0.36})`)
            .attr('font-size', tbl.tSize)
            .attr('fill', col.tColor)
            .attr('text-anchor', col.align)
            .attr('cursor', col.filter !== '' ? 'pointer' : 'default')
            .text( (i>0 && col.group == 'Y' && d[col.code] == this.rawData[i-1][col.code]) ? '' : d[col.code])
            .call(this.call_LINK, i, col.x, mY + tbl.tSize*0.36, col.align, col)
          }
        
        })

        y_ = y_ + tbl.lineHeight
      })
      
    },
  }
}